import { Height, Margin } from "@mui/icons-material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import grey from "@mui/material/colors/grey";

const TableDisplay = ({ columns, rows, disableFirstRow, onRowClick, rowHeight = "20px", columnWidth, minWidth = 70 }) => {
	const tableBorder = disableFirstRow ? `1px solid ${grey[400]}` : `1px solid ${grey[200]}`;

	const cellStyle = {
		// width: "30%",
		borderRight: tableBorder,
		textTransform: "uppercase",
		padding: "0px", // Reduce vertical padding
		// lineHeight: "20px", // Controls text vertical spacing
		minWidth,
		height: rowHeight,
		width: columnWidth ? columnWidth : `${100 / columns.length}%`,
		// padding: "4px 8px",
	};
	const headerCellStyle = {
		borderRight: tableBorder,
		textTransform: "uppercase",

		background: grey[100],
		minWidth,
		height: rowHeight,
		width: columnWidth ? columnWidth : `${100 / columns.length}%`,
		padding: "0px", // Reduce vertical padding
		margin: "0px",
	};
	const headerRowStyle = {
		height: rowHeight,
		overflow: "hidden",
		padding: "0px", // Reduce vertical padding
		margin: "0px",
	};
	const rowStyle = {
		height: rowHeight,
		overflow: "hidden",
		padding: "0px", // Reduce vertical padding
		margin: "0px",
	};
	console.log(rows[0]);
	if (rows[0])
		return (
			<TableContainer sx={{ border: tableBorder }}>
				<Table>
					<TableHead>
						<TableRow sx={headerRowStyle}>
							{columns?.map((row) => (
								<TableCell align="center" key={row.key} sx={headerCellStyle} component="th" scope="row">
									{typeof row?.renderHeader === "function" ? row.renderHeader({ col: row }) : row.name}
								</TableCell>
							))}
						</TableRow>
					</TableHead>
					<TableBody>
						{rows &&
							rows.map((row, index) => (
								<TableRow
									onClick={() => {
										if (typeof onRowClick === "function") onRowClick(row);
									}}
									key={index}
									sx={{
										// "&:last-child td, &:last-child th": { borderBottom: 0 },
										// "&:first-child td, &:first-child th": !disableFirstRoxw
										// 	? {
										// 			background: grey[200],
										// 			fontWeight: "bold",
										// 	  }
										// 	: {},
										...rowStyle,
									}}>
									{columns?.map((col) => (
										<TableCell align="center" key={col.key} sx={cellStyle} component="th" scope="row">
											{typeof col?.renderCell === "function"
												? col.renderCell({ row, field: col.key })
												: row[col.key]}
										</TableCell>
									))}
								</TableRow>
							))}
					</TableBody>
				</Table>
			</TableContainer>
		);
	else return <div>Failed to Display Table</div>;
};

export default TableDisplay;

// import { Box, Typography } from "@mui/material";
// import grey from "@mui/material/colors/grey";

// const TableDisplay = ({ columns, rows, disableFirstRow, onRowClick, rowHeight = "30px", minWidth = 70 }) => {
// 	const tableBorder = disableFirstRow ? `1px solid ${grey[400]}` : `1px solid ${grey[200]}`;

// 	const cellStyle = {
// 		borderRight: tableBorder,
// 		// padding: "0px 8px",
// 		minWidth,
// 		flex: 1,
// 		display: "flex",
// 		alignItems: "center",
// 		justifyContent: "center",
// 		textTransform: "uppercase",
// 		fontSize: "13px",
// 	};

// 	const rowStyle = {
// 		display: "flex",
// 		height: rowHeight,
// 		borderBottom: tableBorder,
// 	};

// 	const headerStyle = {
// 		...cellStyle,
// 		background: grey[100],
// 		fontWeight: 600,
// 	};

// 	if (!rows?.length) return <div>Failed to Display Table</div>;

// 	return (
// 		<Box border={tableBorder} width="100%">
// 			{/* Header Row */}
// 			<Box sx={rowStyle}>
// 				{columns.map((col) => (
// 					<Box key={col.key} sx={headerStyle}>
// 						{typeof col.renderHeader === "function" ? col.renderHeader(col) : col.name}
// 					</Box>
// 				))}
// 			</Box>

// 			{/* Body Rows */}
// 			{rows.map((row, index) => (
// 				<Box
// 					key={index}
// 					sx={{
// 						...rowStyle,
// 						cursor: typeof onRowClick === "function" ? "pointer" : "default",
// 					}}
// 					onClick={() => {
// 						if (typeof onRowClick === "function") onRowClick(row);
// 					}}>
// 					{columns.map((col) => (
// 						<Box key={col.key} sx={cellStyle}>
// 							{typeof col.renderCell === "function" ? col.renderCell(row, col.key) : row[col.key]}
// 						</Box>
// 					))}
// 				</Box>
// 			))}
// 		</Box>
// 	);
// };

// export default TableDisplay;
